"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Iframe = props => {
  if ((0, _lodash.isEmpty)(props.src)) return null;
  var iframe = "<iframe width=100% class=\"".concat(props.fluid ? 'iframe-fluid' : '', "\" scrolling=\"no\" title=\"").concat(props.title, "\" src=\"").concat(props.src, "\" frameborder=\"no\"></iframe>");
  return /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: iframe ? iframe : ""
    }
  });
};
Iframe.propTypes = {
  src: _propTypes.default.string,
  title: _propTypes.default.string,
  fluid: _propTypes.default.bool
};
var _default = exports.default = Iframe;